export default __webpack_public_path__ + "static/media/logo.fa40472b.svg";